import { render } from "./administrator_dashboard.vue?vue&type=template&id=9e8a3e4e&scoped=true"
import script from "./administrator_dashboard.vue?vue&type=script&lang=js"
export * from "./administrator_dashboard.vue?vue&type=script&lang=js"

import "./administrator_dashboard.vue?vue&type=style&index=0&id=9e8a3e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e8a3e4e"]])

export default __exports__